import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { RadioItemProps } from 'src/components/primitives/RadioGroup/types';
import { cm } from 'src/utils/classNames';

export default function RadioItemStandard<T extends string>({
	id,
	value,
	className,
	disabled,
	label,
	size,
	dataTestId,
	// Card-only props — destructured here so they don't leak onto the DOM via `...rest`.
	subLabel: _subLabel,
	rightSlot: _rightSlot,
	layout: _layout,
	...rest
}: RadioItemProps<T>) {
	return (
		<div
			className={cm(
				'group/item flex cursor-pointer items-center gap-x-xs',
				disabled && 'cursor-not-allowed',
				className
			)}
		>
			<RadixRadioGroup.Item
				id={id}
				value={value}
				className={cm(
					'size-lg shrink-0 rounded-full border border-text-secondary bg-input-bg transition-colors',
					'data-disabled:border-button-disabled data-disabled:bg-button-disabled',
					!disabled && [
						'hover:border-text-default',
						'data-[state=checked]:border-purple-link data-[state=checked]:bg-purple-link',
					]
				)}
				disabled={disabled}
				data-testid={dataTestId}
				{...rest}
			>
				<div className="grid size-[12px] place-items-center rounded-full">
					<RadixRadioGroup.RadioGroupIndicator
						className={cm(
							'size-1.5 rounded-full bg-main-bg',
							'data-disabled:bg-text-disabled'
						)}
					/>
				</div>
			</RadixRadioGroup.Item>
			{label && (
				<label
					htmlFor={id}
					className={cm(
						'cursor-pointer text-text-secondary select-none',
						size === 'sm' ? 'typo-body-xs' : 'typo-body-sm',
						disabled && 'cursor-not-allowed text-text-disabled'
					)}
				>
					{label}
				</label>
			)}
		</div>
	);
}
